import styled from "styled-components";
import colors from "../../../../shared/theme/colors";

export const FixedStepControlsContainer = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 128px;
  background-color: #ffffff;
  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px 16px;

  .loading {
    background-color: ${colors.primary};
  }

  .btn-next-step {
    margin-top: 10px;
    width: 100%;
    height: 48px;
    font-size: 16px;
    font-weight: 600;
    border: none;
    border-radius: 12px;
  }

  .total-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .total-text {
    font-size: 14px;
    font-weight: 600;
    color: #455a64;
  }

  .total-value {
    font-size: 20px;
    font-weight: 700;
    color: ${colors.primary};
  }

  .active-button {
    background-color: ${colors.primary};
    color: #ffffff;
  }

  .inactive-button {
    background-color: #eceff1;
    color: #90a4ae;
    pointer-events: none;
  }

  .btn-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.primary};
    color: #ffffff;
    cursor: progress;
    pointer-events: none;
  }

  .btn-spinner {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.4);
    border-top-color: #ffffff;
    animation: btn-spin 0.7s linear infinite;
  }

  @keyframes btn-spin {
    to {
      transform: rotate(360deg);
    }
  }

  .btn-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .btn-back-step {
    display: none;
  }

  .btn-back-mobile {
    display: none;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex: 0 0 auto;
    height: 48px;
    margin-top: 10px;
    padding: 0 20px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 12px;
    background-color: #ffffff;
    color: ${colors.primary};
    border: 1px solid ${colors.primary};
  }

  @media (max-width: 767px) {
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px 16px 20px;

    .actions {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .btn-next-step,
    .btn-back-mobile {
      margin-top: 0;
    }

    .btn-back-mobile {
      display: flex;
    }
  }

  @media (min-width: 768px) {
    position: static;
    height: auto;
    box-shadow: none;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    padding: 20px 24px;

    .total-container {
      display: none;
    }

    .btn-next-step {
      margin: 5px 0;
      width: auto;
      padding: 0 28px;
    }

    > div {
      display: flex;
      gap: 16px;
      padding: 0 16px;
      justify-content: flex-end;
    }

    .btn-back-step {
      display: flex;
      background-color: #eceff1;
      color: ${colors.primary};
      background-color: white;

      svg {
        padding-bottom: 3px;
        width: 20px;
        height: 16px;
      }
    }
  }
`;
